import React, { useContext } from 'react'
import MainNav from '../../components/Navbar/MainNav';
import { useForm, SubmitHandler, useFormState } from 'react-hook-form';
import Spinner from '../../../src/spinner/Spinner'
import { Context } from '../../context/Context';
import axios from 'axios';
import '../../assets/css/Login.css';
import LoginBG from '../../assets/images/login_bg1.jpg'
import LoginTablet from '../../assets/images/login_bg_tablet.jpg'
import LoginMobile from '../../assets/images/login_bg_mobile.jpg'
import {axiosInstance} from '../../utils'

type LoginProps = {
  username: string,
  password: string
}

const Login = () => {
  const { register, formState: { errors, isDirty, isValid }, handleSubmit } = useForm<LoginProps>();
  const onSubmit: SubmitHandler<LoginProps> = async (data) =>  {
   try{
    dispatch({type:"LOGIN_START"});
    const res = await axiosInstance.post('/auth/login', {
      username: data.username,
      password: data.password
    })
    dispatch({type:"LOGIN_SUCCESS", payload: res.data});
    {data && window.location.replace('/')}
   }catch(err) {
    dispatch({type:"LOGIN_FAILURE"})
   }
  }

  const {isFetching, dispatch} = useContext(Context);

  // console.log(user);
  return (
    <div>
      <MainNav/>
      <div className='login__reg__wrapper'>
      <img src={LoginBG} alt="" className='desktop_bg' />
      <img src={LoginTablet} alt="" className='login_tablet' />
      <img src={LoginMobile} alt="" className='login_mobile' />
        <div className='login__reg__contents'>
          <form onSubmit={handleSubmit(onSubmit)}>
          <div className="input__wrap">
              <input type="text" 
                placeholder='username'
                {...register("username", { required: true })} 
              />
            <span className='error'>{errors.username && "username is required"}</span>
          </div>
          <div className="input__wrap">
            <input 
              type="password" 
              placeholder='password'
              {...register("password", { required: true })}
              />
               <span className='error'>{errors.password && "password is required"}</span>
          </div>

               {!isDirty || !isValid ? <button type="submit" disabled>Login</button> : 
                <button type="submit">Login {isFetching && <Spinner />}</button>
               }
          </form>
        </div>
      </div>
    </div>
  )
}

export default Login
